(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/actions.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/actions.js');
"use strict";


const {
  CART_SET_PRODUCT,
  CART_APPEND_PRODUCT,
  CART_REMOVE_PRODUCT_GROUP,
  CART_CLEAR,
  CART_SET_ANIMATION_COMPLETE,
  CART_SET_ERROR,
  CART_CLEAR_ERROR
} = svs.tickets_giftshop.gift.giftform.cart.actiontypes;
const setErrorAction = () => {
  const {
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  return {
    type: CART_SET_ERROR,
    payload: {
      branding
    }
  };
};
const clearErrorAction = () => {
  const {
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  return {
    type: CART_CLEAR_ERROR,
    payload: {
      branding
    }
  };
};
const setRenderAnimationCompleteAction = (productId, productVariation, type, skinId) => {
  const {
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  return {
    type: CART_SET_ANIMATION_COMPLETE,
    payload: {
      productId,
      productVariation,
      type,
      branding,
      skinId
    }
  };
};
const cartClearAction = () => {
  const {
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  return {
    type: CART_CLEAR,
    payload: {
      branding
    }
  };
};
const setProductAction = (productId, productVariation, type, amount, skinId) => {
  const {
    products: {
      products
    },
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  svs.tickets_giftshop.store.dispatch(clearErrorAction());
  return {
    type: CART_SET_PRODUCT,
    payload: {
      productId,
      productVariation,
      type,
      amount,
      products,
      branding,
      skinId
    }
  };
};
const appendProductAction = (productId, productVariation, type, viaQueryString, skinId) => {
  const {
    products: {
      products,
      jupiterProducts
    },
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  svs.tickets_giftshop.store.dispatch(clearErrorAction());
  const productList = viaQueryString ? jupiterProducts : products;
  return {
    type: CART_APPEND_PRODUCT,
    payload: {
      productId,
      productVariation,
      type,
      products: productList,
      branding,
      skinId
    }
  };
};
const removeProductGroupAction = (productId, productVariation, type, skinId) => {
  const {
    settings: {
      branding
    }
  } = svs.tickets_giftshop.store.getState();
  svs.tickets_giftshop.store.dispatch(clearErrorAction());
  return {
    type: CART_REMOVE_PRODUCT_GROUP,
    payload: {
      productVariation,
      productId,
      type,
      branding,
      skinId
    }
  };
};
svs.tickets_giftshop.gift.giftform.cart.actions = {
  cartClearAction,
  setProductAction,
  appendProductAction,
  removeProductGroupAction,
  setRenderAnimationCompleteAction,
  setErrorAction,
  clearErrorAction
};

 })(window);